import { User } from "app/auth/models";

export class Appdata {
    public currentUser?: User;
}
